export default __webpack_public_path__ + "static/media/facial_33.d3840dcb.jpg";